import { createContext } from 'react';

interface CmsComponentsContextValue {
  [key: string]: React.ComponentType<any>;
}

export const CmsComponentsContext = createContext<CmsComponentsContextValue>(
  {}
);
